import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('articoliListino');
export const actions = helper.createActions('articoliListino', actionTypes);
